import { color } from '@upstox/upstox-ui';

export const container: CSSFunction<{ isDisabled: boolean }> =
  ({ theme, cssProps }) => ({
    width: '100%',
    height: '100%',
    backgroundColor: color(theme, 'background.default'),
    ...(cssProps.isDisabled && {
      filter: 'grayscale(1)',
    }),
  });

export const wrapper: CSSFunction = () => ({
  height: '100%',
  overflow: 'hidden',
});

export const fullScreen: CSSFunction<{ height: number }> =
  ({ theme, cssProps }) => ({
    flexDirection: 'column',
    width: '100vw',
    height: cssProps.height,
    backgroundColor: color(theme, 'background.default'),
    zIndex: 1,
  });

  export const iFrameOverlay: CSSFunction = () => ({
    height: '100%',
    width: '100%',
    position: 'absolute',
  });
